import { ILockProps, zIndex } from "interfaces";
import { handleLock } from "redux-share/actions/controller.actions";
import LockIcon from "./lockIcon";

const Lock = ({ className }: ILockProps) => {
    return <LockIcon onClick={() => handleLock("unlock")} style={{ zIndex: zIndex.lockIcon }} className={className} />;
};

export default Lock;
